export const isPresent = val => {
  return val !== undefined;
}
